import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Snackbar,
  Alert,
  Button
} from '@mui/material';
const TITLE = "عداد الاستغفار الإلكتروني - عداد تسبيح واستغفار - المسبحة الرقمية";
const DESCRIPTION = "استخدم عداد الاستغفار الإلكتروني لحساب عدد التسبيحات والاستغفار بسهولة. يوفر لك هذا العداد الرقمي طريقة مريحة لتتبع عدد مرات التسبيح والاستغفار من خلال الضغط على زر التسبيح، كما يمكنك تصفير العداد بسهولة عبر زر التصغير. مثالي للتذكير الروحي ولزيادة التركيز أثناء العبادة.";
const KEYWORDS = "عداد الاستغفار, عداد تسبيح, مسبحة إلكترونية, عداد استغفار أونلاين, عداد تسبيح بدون تحميل, عداد استغفار رقمي";
const OG_URL = "https://do-calculate.com/calculator/ar/tally-counter/";
const TallyCounter = () => {
  const [state, setState] = useState(() => {
    const savedCounts = JSON.parse(localStorage.getItem("counts")) || {};
    const savedCustom = JSON.parse(localStorage.getItem("customTasbeehat")) || [];
    const savedGoals = JSON.parse(localStorage.getItem("tasbeehGoals")) || {};
    return {
      counts: {
        astaghfirullah: savedCounts.astaghfirullah || 0,
        alhamdulillah: savedCounts.alhamdulillah || 0,
        subhanallah: savedCounts.subhanallah || 0,
        laIlahaIllallah: savedCounts.laIlahaIllallah || 0,
        allahuAkbar: savedCounts.allahuAkbar || 0,
        salawat: savedCounts.salawat || 0,
        subhanAllah: savedCounts.subhanAllah || 0,
        laIlahaIllallah2: savedCounts.laIlahaIllallah2 || 0,
        ...savedCounts
      },
      customTasbeehat: savedCustom,
      goals: savedGoals
    };
  });
  const [showModal, setShowModal] = useState(false);
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [currentGoalTasbeeh, setCurrentGoalTasbeeh] = useState("");
  const [goalValue, setGoalValue] = useState("");
  const [newTasbeeh, setNewTasbeeh] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // Function to play goal achievement sound
  const playGoalSound = () => {
    try {
      // Create audio context
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      // Create oscillator for the sound
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      // Configure the sound (celebratory beep)
      oscillator.frequency.value = 800; // Frequency in Hz
      oscillator.type = 'sine';
      // Volume envelope
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      // Play sound
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.log('Audio play failed:', error);
    }
  };
  useEffect(() => {
    localStorage.setItem("counts", JSON.stringify(state.counts));
    localStorage.setItem("customTasbeehat", JSON.stringify(state.customTasbeehat));
    localStorage.setItem("tasbeehGoals", JSON.stringify(state.goals));
  }, [state]);
  const handleIncrement = (key) => {
    setState(prev => {
      const newCount = (prev.counts[key] || 0) + 1;
      const newState = {
        ...prev,
        counts: {
          ...prev.counts,
          [key]: newCount
        }
      };
      if (prev.goals[key] && newCount >= prev.goals[key]) {
        if (newCount === prev.goals[key]) {
          playGoalSound(); // Play sound when goal is reached
          setSnackbarMessage(`مبروك! لقد وصلت إلى هدفك ${prev.goals[key]} تسبيحة!`);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        }
      }
      return newState;
    });
  };
  const handleDecrement = (key) => {
    setState(prev => ({
      ...prev,
      counts: {
        ...prev.counts,
        [key]: Math.max((prev.counts[key] || 0) - 1, 0)
      }
    }));
  };
  const handleReset = (key) => {
    setState(prev => ({
      ...prev,
      counts: {
        ...prev.counts,
        [key]: 0
      }
    }));
  };
  const handleAddTasbeeh = () => {
    if (newTasbeeh.trim() === "") return;
    const key = `custom_${Date.now()}`;
    const formattedKey = key.replace(/\s+/g, '_');
    setState(prev => ({
      ...prev,
      customTasbeehat: [...prev.customTasbeehat, { title: newTasbeeh, key: formattedKey }],
      counts: {
        ...prev.counts,
        [formattedKey]: 0
      }
    }));
    setNewTasbeeh("");
    setShowModal(false);
  };
  const handleRemoveTasbeeh = (key) => {
    setState(prev => {
      const newCounts = { ...prev.counts };
      const newGoals = { ...prev.goals };
      delete newCounts[key];
      delete newGoals[key];
      return {
        ...prev,
        customTasbeehat: prev.customTasbeehat.filter(item => item.key !== key),
        counts: newCounts,
        goals: newGoals
      };
    });
  };
  const handleRemoveGoal = (key) => {
    setState(prev => {
      const newGoals = { ...prev.goals };
      delete newGoals[key];
      return {
        ...prev,
        goals: newGoals
      };
    });
  };
  const handleSetGoal = (key) => {
    setCurrentGoalTasbeeh(key);
    setGoalValue(state.goals[key] || "");
    setShowGoalModal(true);
  };
  const handleSaveGoal = () => {
    if (!goalValue || isNaN(goalValue)) return;
    setState(prev => ({
      ...prev,
      goals: {
        ...prev.goals,
        [currentGoalTasbeeh]: parseInt(goalValue)
      }
    }));
    setShowGoalModal(false);
    setGoalValue("");
    setCurrentGoalTasbeeh("");
  };
  const defaultTasbeehat = [
    { title: "استغفر الله", key: "astaghfirullah" },
    { title: "الحمد لله", key: "alhamdulillah" },
    { title: "سبحان الله", key: "subhanallah" },
    { title: "لا إله إلا الله", key: "laIlahaIllallah" },
    { title: "الله أكبر", key: "allahuAkbar" },
    { title: "اللهم صل على سيدنا محمد", key: "salawat" },
    { title: "سبحان الله وبحمده - سبحان الله العظيم", key: "subhanAllah" },
    { title: "لا اله الا الله وحده لاشريك له له الملك وله الحمد وهو على كل شيءٍ قدير", key: "laIlahaIllallah2" },
    { title: "سبحان الله - الحمدلله - لا إله إلا الله - الله أكبر", key: "combined" },
  ];
  const allTasbeehat = [...defaultTasbeehat, ...state.customTasbeehat];
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>
              حاسبة الاستغفار - المسبحة الالكترونية
            </h1>
          </div>
          <div className="border border-light shadow-lg p-4 rounded" style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "10px",
            boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
          }}>
            <div className="row">
              <div>
                <p>
                  عداد الاستغفار أو عداد التسبيح والاستغفار هو أداة إلكترونية
                  تساعدك على حساب عدد التسبيحات والاستغفار. يمكن استخدام هذا
                  العداد الرقمي بسهولة عن طريق الضغط على الدائرة لتسجيل كل
                  تسبيحة، وكذلك يمكنك تصفير العداد بضغطة على زر التصفير (إعادة
                  التعيين).{" "}
                  <b>
                    يتم حفظ عدادك تلقائياً حتى لو قمت بتحديث الصفحة أو إغلاقها،
                    لكي تستأنف من حيث توقفت.
                  </b>{" "}
                  تعتبر هذه الأداة مثالية لتسهيل عملية الذكر وزيادة التركيز
                  أثناء العبادة.
                  كما يمكنك استخدام هذا العداد لتحديد أهداف معينة للتسبيحات. كما تمتاز هذه الاداة بإصدار صوت تنبيه عند الوصول إلى الهدف المحدد.
                </p>
                <b>بعض الأدعية التي يمكنك استخدامها مع العداد:</b>
                <ul>
                  {defaultTasbeehat.map(item => (
                    <li key={item.key}>{item.title}</li>
                  ))}
                </ul>
                <p>
                  يمكنك أيضاً إضافة تسبيحات خاصة بك من خلال زر "أضف تسبيحة تريدها" أدناه.
                </p>
                <div className=" my-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(true)}
                  >
                    أضف تسبيحة تريدها
                  </button>
                </div>
              </div>
              <div className="alert-info text-center p-3 rounded" style={{ fontSize: "16px" }}>
                يمكنك أيضاً زيارة  <a href="/calculator/ar/athkar-alsabah/" className="text-decoration-none "><strong>عداد أذكار الصباح</strong></a> وأيضا زيارة <a href="/calculator/ar/athkar-almasaa/" className="text-decoration-none fw-bold"><strong>عداد أذكار المساء</strong></a> 
              </div>

            </div>
            <br />
            {allTasbeehat.map((item) => (
              <div className="row" key={item.key} style={{ paddingBottom: "15px" }}>
                <div className="col calculatorStyle">
                  <div className="p-3 mb-2 bg-success text-white text-center">
                    <h2 style={{ fontSize: "24px" }}>{item.title}</h2>
                    {state.customTasbeehat.some(t => t.key === item.key) && (
                      <button
                        className="text-white px-4 py-2 btn btn-secondary"
                        onClick={() => handleRemoveTasbeeh(item.key)}
                        style={{ float: "left", marginTop: "-35px", }}
                      >
                        حذف
                      </button>
                    )}
                  </div>
                  <hr />
                  <div dir="rtl">
                    <div className="text-center my-4">
                      <div
                        style={{
                          background: "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                          color: "#4caf50",
                          borderRadius: "50%",
                          width: "300px",
                          height: "300px",
                          lineHeight: "300px",
                          fontSize: "70px",
                          fontWeight: "bold",
                          margin: "0 auto",
                          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                          cursor: "pointer",
                          userSelect: "none",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }}
                        onClick={() => handleIncrement(item.key)}
                      >
                        {state.counts[item.key] || 0}
                      </div>
                    </div>
                    <br />
                    <div className="text-center mt-2">
                      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        <button
                          className="text-white px-4 py-2"
                          style={{
                            background: "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s",
                            padding: "15px",
                          }}
                          onClick={() => handleDecrement(item.key)}
                        >
                          إنقاص
                        </button>
                        <button
                          className="text-white px-4 py-2"
                          style={{
                            background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s",
                            padding: "15px",
                          }}
                          onClick={() => handleReset(item.key)}
                        >
                          إعادة تعيين
                        </button>
                        <button
                          className="text-white px-4 py-2"
                          style={{
                            background: "linear-gradient(135deg, #4caf50 0%, #81c784 100%)",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            transition: "background 0.3s",
                            padding: "15px",
                          }}
                          onClick={() => handleSetGoal(item.key)}
                        >
                          تحديد هدف
                        </button>
                      </div>
                      {state.goals[item.key] && (
                        <div className="mt-2" style={{ fontSize: "16px", color: "#4caf50" }}>
                          <hr />
                          الهدف:
                          {state.goals[item.key]} - المتبقي: {Math.max(state.goals[item.key] - (state.counts[item.key] || 0), 0)}
                          <br />
                          <button
                            className="text-white px-2 py-1 ms-2"
                            style={{
                              background: "linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)",
                              borderRadius: "15px",
                              fontSize: "18px",
                              fontWeight: "bold",
                              border: "none",
                              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                              transition: "background 0.3s",
                              marginTop: "10px",
                            }}
                            onClick={() => handleRemoveGoal(item.key)}
                          >
                            إزالة الهدف
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <Dialog open={showModal} onClose={() => setShowModal(false)} dir="rtl">
        <DialogTitle>إضافة تسبيحة جديدة</DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: 300, padding: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="tasbeeh-text"
              label="نص التسبيحة"
              type="text"
              fullWidth
              variant="outlined"
              value={newTasbeeh}
              onChange={(e) => setNewTasbeeh(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowModal(false)} color="secondary">
            إلغاء
          </Button>
          <Button onClick={handleAddTasbeeh} color="primary" variant="contained">
            حفظ
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showGoalModal} onClose={() => setShowGoalModal(false)} dir="rtl">
        <DialogTitle>تحديد هدف للتسبيحة</DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: 300, padding: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="goal-value"
              label="عدد التسبيحات المطلوبة"
              type="number"
              fullWidth
              variant="outlined"
              value={goalValue}
              onChange={(e) => setGoalValue(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          {state.goals[currentGoalTasbeeh] && (
            <Button
              onClick={() => {
                handleRemoveGoal(currentGoalTasbeeh);
                setShowGoalModal(false);
              }}
              color="error"
            >
              إزالة الهدف
            </Button>
          )}
          <Button onClick={() => setShowGoalModal(false)} color="secondary">
            إلغاء
          </Button>
          <Button onClick={handleSaveGoal} color="primary" variant="contained">
            حفظ
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default TallyCounter;